import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancelTransfer: 'Cancel transfer',
    cancelTransferHeadline: 'Are you sure you want to cancel this transfer?',
    card: 'Card',
    directDebitCanceledOn: 'Canceled on',
    directDebitPendingOn: 'Planned on',
    directDebitValidatedOn: 'Processed on',
    disputeTransaction: 'Dispute this transaction',
    disputeTransactionBody:
      "Hello, I would like to dispute the transaction # {0} of {1} because I did not authorize it or think it's fraudulent",
    downloadTransferCertificateDescriptionPending:
      'A proof of transfer will be available here once it is validated!',
    downloadTransferCertificateDescriptionValidated:
      'If your need proof that your transfer has been sent, you’ll find it here',
    downloadTransferCertificateLabel: 'Download proof of transfer',
    expectedReleaseOn: 'Bank imprint expiration',
    fromInitiator: 'Made by',
    knowMore: 'Know more about this transaction',
    label: 'Label',
    link: 'All fees pricing',
    mandateReference: 'Mandate reference',
    markAsPersonalDescription:
      "When ticked, this transaction won't be taken into account when computing your taxes. You can identify it with the following icon: ",
    markAsPersonalLabel: 'Personal Transaction',
    needHelp: 'Need help?',
    paymentDate: 'Date',
    PENDING: 'Pending',
    PERSONAL: 'Personal',
    remainingImprint: 'Remaining bank imprint',
    STATUS: 'Status',
    STATUS_CANCELED: 'Canceled',
    STATUS_PENDING: 'Pending',
    transactionAt: '{date} at {time}',
  },
  fr: {
    cancelTransfer: 'Annuler le virement',
    cancelTransferHeadline:
      'Êtes-vous sûr·e de vouloir annuler ce virement\u00A0?',
    card: 'Carte',
    directDebitCanceledOn: 'Annulé le',
    directDebitPendingOn: 'Prévu le',
    directDebitValidatedOn: 'Validé le',
    disputeTransaction: "Contester l'opération",
    disputeTransactionBody:
      "Bonjour, je souhaiterais contester la transaction n° {0} d'un montant de {1} car je n'en suis pas à l'origine ou estime qu'il s'agit d'une transaction frauduleuse.",
    downloadTransferCertificateDescriptionPending:
      'Un justificatif de virement sera disponible ici une fois celui-ci validé\u00A0!',
    downloadTransferCertificateDescriptionValidated:
      'Vous trouverez le justificatif attestant que votre virement a bien été envoyé ici',
    downloadTransferCertificateLabel: 'Télécharger le justificatif de virement',
    expectedReleaseOn: 'Expiration de l’empreinte',
    fromInitiator: 'Réalisée par',
    knowMore: 'En savoir plus sur cette transaction',
    label: 'Libellé',
    link: 'Toutes les commissions',
    mandateReference: 'Référence du mandat',
    markAsPersonalDescription:
      "Lorsque cochée, cette transaction ne sera pas prise en compte dans le calcul de vos cotisations. Vous pourrez la retrouver grâce à l'icône suivante\xa0: ",
    markAsPersonalLabel: 'Transaction personnelle',
    needHelp: 'Besoin d’aide\xa0?',
    note: 'Note',
    paymentDate: 'Date',
    PENDING: 'En attente',
    remainingImprint: 'Empreinte bancaire restante',
    STATUS: 'Statut',
    STATUS_CANCELED: 'Annulée',
    STATUS_PENDING: 'En attente',
    transactionAt: '{date} à {time}',
  },
} as const);

export default locales;
